import { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';

import { About } from './components/About';
import { Header } from './components/Header';
import { LazyShow } from './components/LazyShow';
import { Home } from './pages/Home';
import { Privacy } from './pages/Privacy';
import { TermsAndConditions } from './pages/TermsAndConditions';

export const App = (): ReactElement => {
    return (
        <>
            <div>
                <Header />
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='privacy' element={<Privacy />} />
                    <Route path='terms-and-conditions' element={<TermsAndConditions />} />
                </Routes>

                <LazyShow>
                    <About />
                </LazyShow>
            </div>
        </>
    );
};
